'use strict';

var React = require('react');
var assestsHelper = require('../../helper/assetsHelper');

var VolumeSlider = React.createClass({
  propTypes: {
    opacity: React.PropTypes.string,
    w: React.PropTypes.number,
    h: React.PropTypes.number
  },
  render: function () {
    return (
      <div style={{
        width: '100%',
        height: '100%'
      }}>
        <div className="content">
          <img src={assestsHelper.getComponentAsset('volumeslider')} alt=""/>
        </div>
      </div>
    )
  }
});

module.exports = VolumeSlider;



/** WEBPACK FOOTER **
 ** ./src/views/Components/VolumeSlider.jsx
 **/